import { getEnvValue } from './utils';

const appPort = getEnvValue('NEXT_PUBLIC_APP_PORT');
const appSchema = getEnvValue('NEXT_PUBLIC_APP_PROTOCOL');
const appHost = getEnvValue('NEXT_PUBLIC_APP_HOST');
// 将 isDev 定义提前，供 baseUrl 逻辑使用
const isDev = getEnvValue('NEXT_PUBLIC_APP_ENV') === 'development';
const baseUrl = [
  appSchema || 'https',
  '://',
  appHost,
  // 仅在开发环境或非HTTPS协议下保留端口，生产环境HTTPS访问时自动去除端口
  (appPort && (isDev || appSchema !== 'https')) ? ':' + appPort : '',
].filter(Boolean).join('');
// const isDev = getEnvValue('NEXT_PUBLIC_APP_ENV') === 'development';
const isPw = getEnvValue('NEXT_PUBLIC_APP_INSTANCE') === 'pw';
const spriteHash = getEnvValue('NEXT_PUBLIC_ICON_SPRITE_HASH');

const app = Object.freeze({
  isDev,
  isPw,
  protocol: appSchema,
  host: appHost,
  port: appPort,
  baseUrl,
  useProxy: getEnvValue('NEXT_PUBLIC_USE_NEXT_JS_PROXY') === 'true',
  spriteHash,
});

export default app;